import { render, staticRenderFns } from "./ManheimBatchDetail.vue?vue&type=template&id=3ba6cc4c&scoped=true&"
import script from "./ManheimBatchDetail.vue?vue&type=script&lang=js&"
export * from "./ManheimBatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./ManheimBatchDetail.vue?vue&type=style&index=0&id=3ba6cc4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba6cc4c",
  null
  
)

export default component.exports